<flx-button color="primary" class="login-button" [disabled]="isSubmittingWithAzure" (click)="loginWithAzure()"
	>Log in With Azure <span inlineSVG="assets/icons/azure.svg"></span
></flx-button>
